/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { observer } from 'mobx-react';
import companySearchState from 'Stores/companySearch';
import advSearchState from 'Stores/advSearch';
import { userDetail } from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { CompanyName } from 'Components/common/CompanyList/companyName';
import { CompanyLocation } from 'Components/common/CompanyList/companyLocation';
import CheckBox from 'Components/common/CheckBox';
import { CompanyEmailPhone } from 'Components/common/CompanyList/companyEmailPhone';
import ContactIndustry from 'Components/common/ContactList/ContactIndustry';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import LazyImage from 'Components/common/lazyImage';
import CompanyRevenue from 'Components/common/CompanyList/companyRevenue';
import CompanyEmployeeCount from 'Components/common/CompanyList/companyEmployeeCount';
import CompanyWebsite from 'Components/common/CompanyList/companyWebsite';
import SocialLinks from 'Components/common/SocialLinks';
import { commonMsgPopupState } from 'Components/common/commonMsgPopup';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import AlertSpeakerIcon from 'Assets/png/alert-speaker.png';
import { ReactComponent as UserBoxIcon } from '../../../../assets/svg/company-icon/user-box.svg';

const {
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
} = CONSTANTS;
const { TARGETED_ACCOUNTS, AD_AUDIENCE_LIST } = PERSONALIED_ONBOARDING_FLOWS;
const { LB_GOAL_CURRENT_STEP_VALUE } = MX_PERSONALISED_ONBOARDING_EVENTS;
const { SELECT } = LB_GOAL_CURRENT_STEP_VALUE;

const CompanyListLoadingPlaceHolder = () => {
  return (
    <>
      <div className="contact-list-wrap">
        {Array(10)
          .fill()
          .map((item, index) => {
            return (
              <div className="contact-item" key={index}>
                <div className="contact-check-box-wrap">
                  <div className="common-check-box linear-background" />
                </div>
                <div className="company-logo-wrapper">
                  <div className="logo linear-background" />
                </div>
                <div className="company-info-details">
                  <div className="contact-name linear-background" />
                  <div className="company-location info-item icon-wrap">
                    <div className="svg-icon linear-background" />
                    <div className="item-name linear-background" />
                  </div>
                </div>
                <div className="company-industry-details">
                  <div className="company-industry info-item icon-wrap">
                    <div className="svg-icon linear-background" />
                    <div className="item-name linear-background" />
                  </div>

                  <div className="company-industry-other-info">
                    <div className="company-empcount info-item">
                      <div className="svg-icon linear-background" />
                      <div className="item-name linear-background" />
                    </div>
                    <div className="company-revenue info-item">
                      <div className="svg-icon linear-background" />
                      <div className="item-name linear-background" />
                    </div>
                  </div>
                </div>
                <div className="company-data-details">
                  <div className="company-phone-location">
                    <div className="contact-info info-item">
                      <div className="svg-icon linear-background" />
                      <div className="item-name phone-number linear-background" />
                    </div>
                  </div>
                  <div className="phone-website-wrapper">
                    <div className="company-website info-item">
                      <div className="svg-icon linear-background" />
                    </div>
                    <div className="company-website info-item">
                      <div className="svg-icon linear-background" />
                    </div>
                    <div className="company-website info-item">
                      <div className="svg-icon linear-background" />
                    </div>
                    <div className="company-website info-item">
                      <div className="svg-icon linear-background" />
                    </div>
                  </div>
                </div>
                <div className="company-action">
                  <div className="contact-action-btn total-contacts-btn linear-background" />
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

const CompanyList = observer(props => {
  const {
    data,
    allChecked,
    isListLoading = false,
    contactId,
    setContactId,
  } = props;

  const [addToListOffset, setAddToListOffset] = React.useState({
    top: 0,
    left: 0,
  });

  const contactSelection = (e, index) => {
    if (
      companySearchState.selectedAllContactAcrossPage ||
      companySearchState.selectedContactFromRange
    ) {
      const deselectCallback = () => {
        companySearchState.updateSelectedBulkContactAll(true);
      };
      confirmationPopupState.setPopupValues({
        title: 'Unable to deselect',
        content:
          'Unable to deselect individual items while using "Select all or Range selection". To deselect an item, clear the selection and select items individually.',
        actionBtnText: 'Clear selection',
        callback: deselectCallback,
      });
      confirmationPopupState.setShowPopup(true);
    } else {
      companySearchState.updateSelectedBulkContactIds(index);
    }
  };

  const goToContactTab = (e, domain = '', euCountry = false) => {
    if (domain !== '' && domain !== null) {
      Utils.mixpanelTrack(
        CONSTANTS.MX_AS_EVENTS.AS_LB_COMPANY_PAGE.VIEW_CONTACTS_CLICK,
        { domain },
      );

      const handleGotoContactTab = () => {
        commonMsgPopupState.setShowMsgPopup(false);
        if (
          euCountry &&
          userDetail.featureFlags &&
          userDetail.featureFlags.EU_CONTACTS !== undefined &&
          userDetail.featureFlags.EU_CONTACTS === false
        ) {
          companySearchState.checkEuCountrySearch();
        } else {
          Utils.setLocalStorage('searchJson', {
            companyName: [domain],
            dontDisplayOwnedContacts: true,
            dontDisplayTeamContacts: true,
            dontDisplayDeadContacts: true,
          });
          props.history.push('/advanced-search/contact#search');
          Utils.setLocalStorage('companySearch', false);
          advSearchState.setCurrentPage(0, '', true);
          advSearchState.retainSearch();
          userDetail.setCurrentTab('contact');
        }
      };

      const { isPersonalisedOnboardingFlow } = personalisedOnboardingState;
      if (
        isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ||
        isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST
      ) {
        const handleConfirmClick = () => {
          const eventName = Utils.personalisedOnboardingEventMap(
            isPersonalisedOnboardingFlow,
          );
          if (eventName) Utils.mixpanelTrack(eventName, { movedOut: SELECT });
          personalisedOnboardingState.clearOnboardingFlow();
          handleGotoContactTab();
        };
        const handleCancelClick = () => {
          commonMsgPopupState.setShowMsgPopup(false);
        };
        const description = (
          <>
            By clicking on "view contacts" you will exit the guided tour and
            will be redirected to the contact search page.
            <br />
            This will leave your goal incomplete.
          </>
        );

        commonMsgPopupState.setPopupValues({
          title: 'Do you want to proceed?',
          description,
          customParentClassName: 'skip-tour-confirm-popup',
          actionBtnCallback: handleConfirmClick,
          clickOutsidePopupCallback: handleCancelClick,
          closeClickCallback: handleCancelClick,
          imgComponent: AlertSpeakerIcon,
          showCancelBtn: true,
          showCloseBtn: true,
          cancelBtnText: 'Cancel',
          cancelBtnCallback: handleCancelClick,
          customParentMaskClass: 'skip-tour-confirm-popup-mask',
        });
        commonMsgPopupState.setShowMsgPopup(true);
      } else {
        handleGotoContactTab();
      }
    }
  };

  const listView = data.map((item, index) => {
    return (
      <div className="contact-item" key={index}>
        <div className="contact-check-box-wrap">
          <CheckBox
            dymamicClass={item.checked ? 'selected' : ''}
            onClick={e => contactSelection(e, index)}
          />
        </div>

        <LazyImage
          alt={item.name}
          src={item.logo}
          clsName="logo"
          threshold={200}
          parentClass="company-logo-wrapper"
        />

        <div className="company-info-details">
          <CompanyName name={item.name} parentClass="company-name-wrapper" />
          <CompanyLocation
            city={item.city}
            state={item.state}
            country={item.country}
            showToolTipOnHover
          />
        </div>
        <div className="company-industry-details">
          <ContactIndustry
            industry={item.industry}
            employeeCount={item.employeeCount}
            revenue={item.revenue}
            showNA={false}
          />
        </div>
        <div className="company-data-details">
          <CompanyEmailPhone
            contactId={item.id}
            phone={item.phone}
            isDownloaded
          />
          <div className="phone-website-wrapper">
            <CompanyWebsite primaryDomain={item.primaryDomain} />
            <SocialLinks {...item} />
          </div>
        </div>
        <div className="company-action">
          {item.contactCount !== null &&
            item.contactCount !== undefined &&
            item.contactCount > 0 && (
              <div
                className="contact-action-btn total-contacts-btn"
                onClick={e =>
                  goToContactTab(e, item.primaryDomain, item.euCountry)
                }
              >
                <UserBoxIcon className="svg-icon" />
                <span>{Utils.usNumberFormat(item.contactCount)}</span>&nbsp;
                <span>{item.contactCount > 1 ? 'Contacts' : 'Contact'}</span>
              </div>
            )}
        </div>
      </div>
    );
  });

  return isListLoading ? (
    <div className="contact-list company-list company-list-loading-placeholder">
      <CompanyListLoadingPlaceHolder />
    </div>
  ) : (
    <div className="contact-list company-list">
      <div className="contact-list-wrap">{listView}</div>
    </div>
  );
});

export { CompanyList };
export default CompanyList;
